<template>
  <!--  :headStyle="{borderBottom:'0px'}" -->
  <a-card
    :bordered="false"
    :bodyStyle="{ paddingTop: '0px' }"
    title="账单详情"
    :headStyle="{ borderBottom: '0px', fontSize: '18px' }"
  >
    <a-card :bordered="false" :bodyStyle="{ padding: '0px' }" :headStyle="{ borderBottom: '0px', paddingLeft: '0px' }">
      <a-row slot="title">
        <a-col :span="8">
          <span class="card-title">账单汇总信息</span>
        </a-col>
      </a-row>
      <a-table rowKey="statementId" :pagination="false" :columns="columns" :dataSource="data">
        <span slot="statementIncomeTotal" slot-scope="text">+{{ text }}</span>
        <span slot="statementExpenditureTotal" slot-scope="text">{{ text }}</span>
        <span slot="statementStatus" slot-scope="text">
          {{ text | statementStatusName }}
        </span>
        <div v-if="statementStatus == 2" slot="action" slot-scope="record">
          <a-popconfirm title="是否要确认账单?" @confirm="toConfirm(record)">
            <a>确认账单</a>
          </a-popconfirm>
        </div>
        <div v-else>
          <a @click="warning">确认账单</a>
        </div>
      </a-table>
    </a-card>
    <a-card :bordered="false" :bodyStyle="{ padding: '0px' }" :headStyle="{ borderBottom: '0px', paddingLeft: '0px' }">
      <a-row slot="title">
        <a-col :span="8">
          <span class="card-title">账单明细信息</span>
        </a-col>
      </a-row>
      <div style="margin-bottom: 20px;">
        <a-radio-group @change="onChange" defaultValue="1">
          <a-radio-button value="1">收支明细</a-radio-button>
          <a-radio-button value="2">调整明细</a-radio-button>
        </a-radio-group>
      </div>
      <div v-if="detailRadio == 1">
        <IncomeComponent></IncomeComponent>
      </div>
      <div v-else>
        <AdjustComponent></AdjustComponent>
      </div>
    </a-card>
  </a-card>
</template>

<script>
import IncomeComponent from '../components/IncomeComponent'
import AdjustComponent from '../components/AdjustComponent'

export default {
  name: 'CheckUnitDetails',
  components: {
    IncomeComponent,
    AdjustComponent
  },
  data() {
    return {
      detailRadio: 1,
      statementStatus: '',
      selectedDate: undefined,
      statusList: [],
      statementId: '',
      data: [],
      columns: [
        {
          title: '结算周期',
          dataIndex: 'statementDate'
        }, {
          title: '本期收入合计',
          dataIndex: 'statementIncomeTotal',
          scopedSlots: { customRender: 'statementIncomeTotal' }
        },
        {
          title: '本期支出合计',
          dataIndex: 'statementExpenditureTotal',
          scopedSlots: { customRender: 'statementExpenditureTotal' }
        },
        {
          title: '上期账户余额',
          dataIndex: 'statementPreviousBalance'
        },
        {
          title: '当前账户余额',
          dataIndex: 'statementCurrentBalance'
        },
        {
          title: '平台调整金额',
          dataIndex: 'statementAdjustmentAmount'
        },
        {
          title: '合计应付总额',
          dataIndex: 'statementTotalAmount'
        },
        {
          title: '对账状态',
          dataIndex: 'statementStatus',
          scopedSlots: { customRender: 'statementStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.getAllAccountData()
  },
  methods: {
    onChange(e) {
      this.detailRadio = e.target.value
      this.getLogUtils().logWithTag('明细选择', this.detailRadio)
    },
    getAllAccountData(params) {
      this.statementId = this.$route.query.statementId
      return this.getHttpServices().getUserService().post('api/v2/financialTransactionr/billingSummaryDetails', {
        statementId: this.statementId
      }).then(res => {
        this.statementStatus = res.statementStatus
        var obj = res //定义对象
        var data = [] //定义数组
        data.push(obj)
        this.data = data
        this.getLogUtils().logWithTag('----------------------', this.statementStatus)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    warning() {
      this.$message.warning('无法操作')
    },
    toConfirm(record) {
      this.getHttpServices().getUserService().post('api/v2/financialTransactionr/confirmBill', {
        statementId: this.statementId
      }).then(res => {
        this.$message.success('账单提交成功')
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.$message.error('账单提交失败')
      })
    }
  }

}
</script>
<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.status-list {
  background-color: #f5f5f6;
  padding: 20px;
  font-size: 18px;
  margin-bottom: 20px;
  border-radius: 8px;

  .text {
    margin-bottom: 10px;
  }

  .heading {
    span {
      color: #fea834;
    }
  }
}
</style>